import { IconProps } from '@bonanza-social/moonlight';
import { QuestRewardTarget } from '../../state';

export const rewardIconMap: Record<QuestRewardTarget, IconProps['name']> = {
  Coins: 'bonanzaCoin',
  Cash: 'bonanzaDollar',
  Bonus: 'bonanzaDollar',
  FreeSpins: 'slotsDark',
  InstantWheel: 'spinWheel',
  Wheel: 'metaWheel',
  Scratcher: 'scratchcards',
};
